module.exports = __webpack_public_path__ + "static/aerial-views-ix-50895800fd80d79db07a2c97e40de276.jpg";